import axios from "../axiosPlugin.js";

export const getCinemaDailyListService = (data, loading = true) => {
  return axios({
    url: "/api/cinemaDaily/list",
    method: "get",
    data: {
      data,
      loading,
    },
  });
};

export const createCinemaDailyListService = (data, loading = true) => {
  return axios({
    url: "/api/cinemaDaily/create",
    method: "post",
    data: {
      data,
      loading,
    },
  });
};

export const updateCinemaDailyListService = (data, loading = true) => {
  return axios({
    url: "/api/cinemaDaily/update",
    method: "post",
    data: {
      data,
      loading,
    },
  });
};

export const getCinemaDailyDetailService = (id, loading = true) => {
  return axios({
    url: `/api/cinemaDaily/detail/${id}`,
    method: "get",
    data: {
      loading,
    },
  });
};

export const deleteCinemaDailyService = (data, loading = true) => {
  return axios({
    url: `/api/cinemaDaily/delete/${data.id}`,
    method: "get",
    data: {
      data,
      loading,
    },
  });
};

